import { render, staticRenderFns } from "./m-consommable.html?vue&type=template&id=236869eb&scoped=true&external"
import script from "./m-consommable.js?vue&type=script&lang=js&external"
export * from "./m-consommable.js?vue&type=script&lang=js&external"
import style0 from "./m-consommable.scss?vue&type=style&index=0&id=236869eb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236869eb",
  null
  
)

export default component.exports